import { createContext } from 'react';

// Contains Header ref
const HeaderContext = createContext(null);

export default HeaderContext;
